import React from 'react'
import { Box } from '@mui/material'

/**
 * A persistent banner shown only on the test environment build
 * (when REACT_APP_ENVIRONMENT === 'test'). It is intentionally loud so
 * nobody mistakes the test site for the live booking site.
 */
const TestEnvironmentBanner = () => (
  <Box
    role="alert"
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1250,
      width: '100%',
      backgroundColor: '#b45309',
      color: '#fff',
      textAlign: 'center',
      fontWeight: 700,
      fontSize: '0.8125rem',
      lineHeight: 1.4,
      py: 0.75,
      px: 2
    }}
  >
    ⚠ TEST ENVIRONMENT — bookings made here are not real and will not be processed.
  </Box>
)

export default TestEnvironmentBanner
